import Predective from "./Predective.container";

export default Predective;
